import { CreateInfo } from '@/config/types';
import { apiConfig } from '@/services/api-config';

export default async function (resp: CreateInfo) {
  return apiConfig
    .post('api/TerritoryAccess/create', resp)
    .then((response) => response.data)
    .catch(() => {
      return false;
    });
}
